<template>
  <span v-if="category && category.label">{{ category.label }}:</span>
</template>

<script>

export default {
  name: "CategoryInfo",
  props: {
    categoryId: String,
    report: Object
  },
  data() {
    return {
      category: {}
    }
  },
  methods: {
    getCategoryList() {
      this.category = this.report.categorylist.find(c => c.code === this.categoryId);
    },
  },
  created() {
    this.getCategoryList();
  },
}
</script>
